// html2canvas 는 호출마다 문서 전체를 숨은 iframe 에 복제한다. 복제 비용은 "제외되지 않은
// 노드 수" 에 비례하는데, 기존 구현은 Vue 시절 잔재인 Vuetify 셀렉터
// (`.v-application > div:not(.v-dialog__content--active)`)를 찾고 있어 React 앱에서는
// 한 건도 매치하지 않았다 — 즉 아무것도 제외하지 못한 채, 화면의 라이브 리포트와
// 미리보기 사본을 섹션마다 통째로 복제했다.
//
// 2026-08-21 실측 (Activity Report, 선수 22명, 창 1268px):
//   문서 전체 10,046 노드 중 캡처에 필요한 미리보기는 3,645 노드(36%) — 나머지 64% 는 낭비
//   생성 31.3초 가운데 복제가 27.9초(89%), 실제 렌더링은 0.8초(2.5%)
export const HTML2CANVAS_IGNORE_ATTR = "data-html2canvas-ignore"

/**
 * 캡처 대상으로 가는 경로 밖의 노드를 전부 제외 표시해, html2canvas 의 복제 범위를
 * 캡처 트리로 좁힌다.
 *
 * `<head>` 는 건드리지 않는다 — 제외하면 복제본에 스타일시트가 없어 무스타일로 캡처된다
 * (WEB-2272 와 같은 증상). 그래서 body 에 도달하면 순회를 멈춘다.
 */
export function markHtml2CanvasIgnoreOutside(captureRoot: Element | null | undefined) {
  if (!captureRoot) {
    return
  }

  let node: Element | null = captureRoot
  while (node && node !== document.body) {
    const parent: HTMLElement | null = node.parentElement
    if (!parent) {
      break
    }

    const current = node
    Array.from(parent.children).forEach((sibling) => {
      if (sibling !== current) {
        sibling.setAttribute(HTML2CANVAS_IGNORE_ATTR, "")
      }
    })

    node = parent
  }
}

/**
 * 문서 전역의 제외 표시를 걷어낸다.
 * 캡처를 마친 섹션에도 표시가 붙으므로(parseImage), 재실행 시 빈 캡처가 되지 않도록
 * 생성 시작과 종료 양쪽에서 호출한다.
 */
export function clearHtml2CanvasIgnore() {
  document
    .querySelectorAll(`[${HTML2CANVAS_IGNORE_ATTR}]`)
    .forEach((el) => el.removeAttribute(HTML2CANVAS_IGNORE_ATTR))
}
